export class DataPeriod {

    constructor(
        public start: string = "",
        public end: string = "",
    ) { }

    public getStartString() : string {
        return this.start;
    }

    public getEndString() : string {
        return this.end;
    }

    public equals(another: DataPeriod) : boolean {
        return this.start == another.start &&
                this.end == another.end;
    }
}

